export const accountNumber = value => value == null || value === '' || !Number.isFinite(Number(value)) ? null : Number(value);
export function todaySeedanceSummary(rows, now = new Date()) {
  const date = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
  return rows.find(row => typeof row.date === 'string' && row.date.slice(0, 10) === date) || { total_cost: 0, total_calls: 0 };
}
